// When adding new cases make sure to add to en.lyaml chat.copilotName.<newAssistantType>
export const BREEZE_COPILOT = 'breezeCopilot';
export const SALES_COPILOT = 'salesCopilot';
// TODO: Remove this once the BE version is rolled out.
export const INTERACTIVE_MODE = 'interactiveMode';
export const CHAT_AGENT = 'chatAgent';